// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e9024fb","239":"09ce29e7","453":"48e4d5c1","732":"afce4722"}[chunkId] + ".chunk.js";
};